<template>
  <v-app>
    <router-view />
    <ReauthenticationDialog />
  </v-app>
</template>

<script>
import AppNavigation from "@/components/app/navigation";
import ReauthenticationDialog from "@/components/dialogs/reauthentication";
import AppHeader from "@/components/app/header";

export default {
  components: {
    AppHeader,
    AppNavigation,
    ReauthenticationDialog
  }
};
</script>
